import { render, staticRenderFns } from "./EnterpriseTable.vue?vue&type=template&id=2b876215&scoped=true&"
import script from "./EnterpriseTable.vue?vue&type=script&lang=js&"
export * from "./EnterpriseTable.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseTable.vue?vue&type=style&index=0&id=2b876215&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b876215",
  null
  
)

export default component.exports